"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFormatter = void 0;
var React = require("react");
var CSSMacros_1 = require("./CSSMacros");
var DefaultFormatter = function (props) {
    var _a = React.useState(undefined), tooltip = _a[0], setTooltip = _a[1];
    var handleMouseEnter = function (e) {
        if (e.currentTarget.clientWidth < e.currentTarget.scrollWidth) {
            setTooltip(e.currentTarget.textContent || undefined);
        }
    };
    return React.createElement("div", { children: props.value, "data-tb-test-id": props.testId, onMouseEnter: handleMouseEnter, style: CSSMacros_1.Elided, title: tooltip });
};
exports.DefaultFormatter = DefaultFormatter;
exports.DefaultFormatter.displayName = 'DataGridDefaultFormatter';
//# sourceMappingURL=DefaultFormatter.js.map